'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withColor = require('../with-color/with-color');

var _withColor2 = _interopRequireDefault(_withColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function withTypography(Component) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var WithTypography = function WithTypography(_ref) {
    var _ref$align = _ref.align,
        align = _ref$align === undefined ? defaults.align : _ref$align,
        className = _ref.className,
        _ref$transform = _ref.transform,
        transform = _ref$transform === undefined ? defaults.transform : _ref$transform,
        _ref$weight = _ref.weight,
        weight = _ref$weight === undefined ? defaults.weight : _ref$weight,
        truncate = _ref.truncate,
        italic = _ref.italic,
        props = _objectWithoutProperties(_ref, ['align', 'className', 'transform', 'weight', 'truncate', 'italic']);

    var classes = (0, _classnames2.default)('typography', align && 'typography--align-' + align, transform && 'typography--transform-' + transform, weight && 'typography--weight-' + weight, truncate && 'typography--truncate', italic && 'typography--italic', className);

    return _react2.default.createElement(Component, _extends({ className: classes }, props));
  };

  WithTypography.propTypes = _extends(Component.propTypes, {
    align: _propTypes2.default.oneOf(['left', 'center', 'right']),
    className: _propTypes2.default.string,
    transform: _propTypes2.default.oneOf(['capitalize', 'lowercase', 'uppercase']),
    weight: _propTypes2.default.oneOf(['light', 'regular', 'medium', 'bold', 'extra-bold']),
    truncate: _propTypes2.default.bool
  });

  return (0, _withColor2.default)(WithTypography, defaults);
}

exports.default = withTypography;